import { SITE, spotsLeft } from "../config";

export const SpotsBadge = ({ testId = "hero-spots-counter", className = "" }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-2.5 rounded-full border border-volt/25 bg-volt/[0.06] px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] text-volt ${className}`}
  >
    <span className="relative flex h-2 w-2">
      <span className="absolute inline-flex h-full w-full animate-pulse-dot rounded-full bg-volt" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-volt" />
    </span>
    {spotsLeft} of {SITE.totalSpots} founding spots left
  </span>
);
